import { getIpViaStun } from './core/stun';

/**
 * Composable hook providing WebRTC-related utilities.
 * @see src/webrtc/README.md
 * @link https://developer.mozilla.org/en-US/docs/Web/API/WebRTC_API
 */
export function useWebRTC() {
  return { getIpViaStun };
}
